import { useState } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Link, paths } from 'shared/base';

interface Props {
  onAccepted: () => void;
  open: boolean;
}

export const TrackingConsentPrompt = ({ onAccepted, open }: Props) => {
  const labelId = 'tracking-consent-prompt';

  const [accepted, setAccepted] = useState(false);

  return (
    <Dialog aria-labelledby={labelId} fullWidth={true} open={open}>
      <DialogTitle id={labelId}>
        <Box alignItems="center" display="flex" justifyContent="space-between">
          <Typography variant="h6">One last thing - Terms of service and Privacy policy</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="body2">
            To finish creating your account, please confirm accepting CloudQuery Terms of Service
            and Privacy Policy.
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={accepted}
                onChange={(event) => {
                  setAccepted(event.target.checked);
                }}
                tabIndex={-1}
              />
            }
            label={
              <Typography variant="body2">
                I accept the CloudQuery{' '}
                <Link href={paths.platformDocs.termsOfService} target="_blank">
                  Terms of Service
                </Link>{' '}
                and{' '}
                <Link href={paths.platformDocs.privacyPolicy} target="_blank">
                  Privacy Policy
                </Link>
                .
              </Typography>
            }
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button disabled={!accepted} onClick={onAccepted} size="medium" variant="contained">
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};
